module.exports = __webpack_public_path__ + "media/images/icons/bulb-0eda5489219edf7fd11be48f0dc50209.svg";